// ── App-wide constants ────────────────────────────────────────────────────────

export const KUWAIT_GOVERNORATES_DATA = [
  {
    name: "العاصمة", nameEn: "Capital",
    areas: [
      { name: "الشرق",                 nameEn: "Sharq" },
      { name: "قبلة",                  nameEn: "Qibla" },
      { name: "المرقاب",               nameEn: "Mirqab" },
      { name: "الصوابر",               nameEn: "Sawaber" },
      { name: "الوطية",                nameEn: "Watiya" },
      { name: "الدسمة",                nameEn: "Dasman" },
      { name: "الدعية",                nameEn: "Daiya" },
      { name: "الشامية",               nameEn: "Shamiya" },
      { name: "النزهة",                nameEn: "Nuzha" },
      { name: "الفيحاء",               nameEn: "Faiha" },
      { name: "كيفان",                 nameEn: "Kaifan" },
      { name: "الروضة",                nameEn: "Rawda" },
      { name: "الأندلس",               nameEn: "Andalous" },
      { name: "غرناطة",                nameEn: "Granada" },
      { name: "الخالدية",              nameEn: "Khaldiya" },
      { name: "القادسية",              nameEn: "Qadisiya" },
      { name: "العديلية",              nameEn: "Adailiya" },
      { name: "العقيلة",               nameEn: "Oqaila" },
      { name: "الدوحة",                nameEn: "Doha" },
      { name: "السرة",                 nameEn: "Surra" },
      { name: "المنصورية",             nameEn: "Mansouriya" },
      { name: "بنيد القار",            nameEn: "Bneid Al-Qar" },
      { name: "أم الهيمان الإدارية",   nameEn: "Umm Al-Haiman" },
      { name: "الصليبخات",             nameEn: "Sulaibikhat" },
      { name: "الشويخ السكني",         nameEn: "Shuwaikh Residential" },
      { name: "الشويخ الصناعي",        nameEn: "Shuwaikh Industrial" },
      { name: "عمر بن الخطاب",         nameEn: "Omar Bin Al-Khattab" },
      { name: "فيلكا",                 nameEn: "Failaka" },
    ],
  },
  {
    name: "حولي", nameEn: "Hawalli",
    areas: [
      { name: "حولي",      nameEn: "Hawalli" },
      { name: "السالمية",  nameEn: "Salmiya" },
      { name: "الرميثية", nameEn: "Rumaithiya" },
      { name: "مشرف",     nameEn: "Mishref" },
      { name: "الرقة",    nameEn: "Ruqa" },
      { name: "بيان",     nameEn: "Bayan" },
      { name: "الزهراء",  nameEn: "Zahra" },
      { name: "الجابرية", nameEn: "Jabriya" },
      { name: "حطين",     nameEn: "Hittin" },
      { name: "الشعب",    nameEn: "Shaab" },
      { name: "الشهداء",  nameEn: "Shuhada" },
      { name: "النقرة",   nameEn: "Naqra" },
      { name: "الرقعي",   nameEn: "Ruqai" },
      { name: "سلوى",     nameEn: "Salwa" },
      { name: "العدان",   nameEn: "Adan" },
    ],
  },
  {
    name: "الفروانية", nameEn: "Farwaniya",
    areas: [
      { name: "الفروانية",           nameEn: "Farwaniya" },
      { name: "العارضية",            nameEn: "Ardiya" },
      { name: "الرابية",             nameEn: "Rabiya" },
      { name: "الريحان",             nameEn: "Rihan" },
      { name: "خيطان",               nameEn: "Khaitan" },
      { name: "العمرية",             nameEn: "Umairiya" },
      { name: "الضجيج",              nameEn: "Dajej" },
      { name: "الفروانية الصناعي",   nameEn: "Farwaniya Industrial" },
      { name: "جليب الشيوخ",         nameEn: "Jleeb Al-Shuyoukh" },
      { name: "ربيع البصيل",         nameEn: "Rabee Al-Baseel" },
      { name: "الشدادية",            nameEn: "Shadadiya" },
      { name: "العارضية الصناعي",    nameEn: "Ardiya Industrial" },
      { name: "النسيم",              nameEn: "Al-Naseem" },
      { name: "القيروان",            nameEn: "Qairawan" },
      { name: "الوسطى",              nameEn: "Wustah" },
    ],
  },
  {
    name: "الأحمدي", nameEn: "Ahmadi",
    areas: [
      { name: "الأحمدي",            nameEn: "Ahmadi" },
      { name: "الفحيحيل",           nameEn: "Fahaheel" },
      { name: "المنقف",             nameEn: "Mangaf" },
      { name: "المهبولة",           nameEn: "Mahboula" },
      { name: "الصباحية",           nameEn: "Sabahiya" },
      { name: "صباح السالم",        nameEn: "Sabah Al-Salem" },
      { name: "هدية",               nameEn: "Hadiya" },
      { name: "بنيدر",              nameEn: "Bneidar" },
      { name: "الظهر",              nameEn: "Dhaher" },
      { name: "الزور",              nameEn: "Zour" },
      { name: "النويصيب",           nameEn: "Nuwaiseeb" },
      { name: "الوفرة",             nameEn: "Wafra" },
      { name: "الشعيبة",            nameEn: "Shuaiba" },
      { name: "الخيران",            nameEn: "Khairan" },
      { name: "الجليعة",            nameEn: "Julaiaa" },
      { name: "ضاحية جابر العلي",   nameEn: "Jaber Al-Ali" },
      { name: "علي صباح السالم",    nameEn: "Ali Sabah Al-Salem" },
      { name: "أبو حليفة",          nameEn: "Abu Halifa" },
      { name: "ميناء عبدالله",      nameEn: "Abdullah Port" },
      { name: "الفنيطيس",           nameEn: "Funaitees" },
      { name: "أبو فطيرة",          nameEn: "Abu Futaira" },
    ],
  },
  {
    name: "مبارك الكبير", nameEn: "Mubarak Al-Kabeer",
    areas: [
      { name: "مبارك الكبير",        nameEn: "Mubarak Al-Kabeer" },
      { name: "المسيلة",             nameEn: "Masayeel" },
      { name: "القرين",              nameEn: "Qurain" },
      { name: "القصور",              nameEn: "Qusor" },
      { name: "الصديق",              nameEn: "Siddeeq" },
      { name: "ضاحية صباح السالم",   nameEn: "Sabah Al-Salem Suburb" },
    ],
  },
  {
    name: "الجهراء", nameEn: "Jahra",
    areas: [
      { name: "الجهراء",          nameEn: "Jahra" },
      { name: "القصر",            nameEn: "Qasr" },
      { name: "تيماء",            nameEn: "Taima" },
      { name: "الأمير",           nameEn: "Amir" },
      { name: "الجهراء القديمة",  nameEn: "Old Jahra" },
      { name: "الواحة",           nameEn: "Waha" },
      { name: "الصليبية",         nameEn: "Sulaibiya" },
      { name: "كاظمة",            nameEn: "Kadhma" },
      { name: "الوهيبة",          nameEn: "Wahiba" },
      { name: "العيون",           nameEn: "Uyoun" },
      { name: "النعيم",           nameEn: "Naeem" },
      { name: "برقان",            nameEn: "Burqan" },
    ],
  },
];

export const DEFAULT_AREAS = [
  "الشويخ الصناعي","الشويخ السكني","غرناطة","الروضة","الخالدية","عمر بن الخطاب",
  "الأندلس","القادسية","فيلكا","العديلية","العقيلة","أم الهيمان الإدارية",
  "الدسمة","الدعية","السرة","الشامية","المنصورية","النزهة","الفيحاء","الصليبخات",
  "ميناء عبدالله","الشرق","الدوحة","قبلة","المرقاب","الصوابر","الوطية",
  "حولي","السالمية","الرميثية","مشرف","الرقة","البيان","الزهراء","الجابرية",
  "بيان","النقرة","حطين","الشعب","الشهداء","بنيد القار","أبو حليفة",
  "الفروانية","العارضية","الرابية","الريحان","خيطان","أبو فطيرة","العمرية",
  "الضجيج","الفنيطيس","الفروانية الصناعي","جليب الشيوخ","ربيع البصيل",
  "الشدادية","العارضية الصناعي","النسيم","القيروان","الوسطى","الرقعي",
  "الأحمدي","الفحيحيل","المنقف","المهبولة","الصباحية",
  "صباح السالم","هدية","بنيدر","الظهر","الزور","النويصيب","الوفرة",
  "الشعيبة","الخيران","الجليعة","ضاحية جابر العلي","علي صباح السالم",
  "الجهراء","القصر","تيماء","الأمير","الجهراء القديمة","الواحة",
  "الصليبية","كاظمة","الوهيبة","العيون","النعيم","برقان",
  "مبارك الكبير","المسيلة","القرين","القصور","الصديق","ضاحية صباح السالم","سلوى","العدان",
].sort((a,b)=>a.localeCompare(b,"ar"));

export const QUICK_PRICES = [2.5, 3, 5];
export const today = new Date().toISOString().split("T")[0];
export const yesterday = new Date(Date.now()-86400000).toISOString().split("T")[0];
export const COMPANY_ID_DEFAULT = "01";
export const COMPANY_PASS_DEFAULT = "123456";
export const SESSION_KEY = "bekvam_session";

export const DEFAULT_NOTIF_SETTINGS = {
  newOrder_company:        true,
  assignDriver_company:    true,
  assignDriver_driver:     true,
  assignTailor_company:    true,
  assignTailor_tailor:     true,
  clientPaid_company:      true,
  noFabric_company:        true,
  fabricProvided_tailor:   true,
  tailorDone_company:      true,
  driverDone_company:      true,
  driverPaid_company:      true,
  driverPaid_driver:       true,
  inStock_company:         true,
  assignPacker_company:    true,
  assignPacker_packer:     true,
  packingDone_company:     true,
};

export const DEFAULT_WEBSITE_SETTINGS = {
  storeName: "بيكڤام",
  storeNameEn: "Bekvam",
  storeDescription: "متجر إلكتروني متكامل",
  logoUrl: "",
  primaryColor: "#607878",
  secondaryColor: "#4ecb8d",
  fontFamily: "Cairo",
  theme: "light",
  whatsappNumber: "",
  instagramUrl: "",
  twitterUrl: "",
  aboutText: "",
  workingHours: "السبت - الخميس: 9ص - 9م",
  deliveryAreas: [],
  minOrderAmount: 0,
  freeDeliveryThreshold: 0,
  estimatedDeliveryDays: "2-3",
  paymentMethods: { cashOnDelivery: true, kNet: false, creditCard: false },
  banners: [],
  announcementBar: { texts: [{ ar: "", en: "" }], enabled: false, color: "#4ecb8d", textColor: "#ffffff", position: "top", height: 36, speed: 4, motion: "fade" },
  products: [],
  categories: [],
  storeEnabled: true,
  storeClosedMessage: "المتجر مغلق حالياً",
  imgbbApiKey: "",
  cloudinaryCloudName: "",
  cloudinaryUploadPreset: "",
  template: "classic",
  sections: {
    heroTitle: "اكتشف أحدث تشكيلاتنا",
    heroSubtitle: "جودة عالية وأسعار مناسبة",
    heroButtonText: "تسوق الآن",
    heroBgImage: "",
    featuredTitle: "منتجاتنا",
    promoEnabled: true,
    promoTitle: "عروض خاصة",
    promoSubtitle: "خصومات حصرية على أفضل المنتجات",
    promoButtonText: "اكتشف الآن",
    promoBgColor: "#4ecb8d",
    showAbout: false,
    aboutTitle: "من نحن",
    aboutText: "",
  },
  builder: {
    header: {
      height: 60,
      bgColor: "",
      logoPosition: "right",
      logoSize: 36,
      cartPosition: "left",
      searchVisible: true,
      searchPosition: "right",
      burgerVisible: true,
      burgerPosition: "left",
      iconSize: 22,
    },
    banner: { enabled: true, items: [] },
    categories: { enabled: false, items: [] },
    productSections: [],
    footer: {
      bgColor: "#1a1a2e",
      textColor: "#ffffff",
      showLogo: true,
      logoPosition: "center",
      showStoreName: true,
      showDescription: true,
      showWhatsapp: true,
      showInstagram: true,
      showTwitter: true,
      showWorkingHours: true,
      copyrightText: "",
    },
  },
  popup: {
    enabled: false,
    bgColor: "#ffffff",
    overlayColor: "#000000",
    overlayOpacity: 0.5,
    title: "",
    titleColor: "#1a2a2a",
    titleSize: 20,
    bodyText: "",
    bodyColor: "#555555",
    bodySize: 14,
    imageUrl: "",
    buttonEnabled: false,
    buttonText: "تسوق الآن",
    buttonColor: "#607878",
    buttonTextColor: "#ffffff",
    buttonSize: 13,
    buttonLink: "",
    copyEnabled: false,
    copyCode: "",
    copyButtonText: "نسخ الكود",
    copyButtonColor: "#4ecb8d",
    copyButtonTextColor: "#ffffff",
    copyButtonSize: 13,
    showOnce: true,
    delaySeconds: 0,
  },
};

export const DEFAULT_ECOM_CONFIG = {
  storeName: "بيكڤام",
  storeNameEn: "Bekvam",
  storeDescription: "متجر إلكتروني متكامل",
  logoUrl: "",
  logoUrlAr: "",
  imgbbApiKey: "",
  cloudinaryCloudName: "",
  cloudinaryUploadPreset: "",
  imageUploadPlatform: "cloudinary",
  template: "minimal",
  fontAr: "Cairo",              // خط المتجر للنصوص العربية (أي خط من Google Fonts)
  fontEn: "Playfair Display",   // خط المتجر للنصوص الإنجليزية
  primaryColor: "#607878",
  accentColor: "#4ecb8d",
  bannerEnabled: true,        // إظهار بنر الصفحة الرئيسية (false = مغلق كلياً)
  pdImageRatio: 100,          // صفحة المنتج: ارتفاع بوكس الصورة كنسبة من العرض (%)
  pdImageFit: "contain",      // contain (الصورة كاملة) | cover (تملأ البوكس)
  showShareBtn: true,         // زر مشاركة واتساب في صفحة المنتج
  pdAutoSelectVariant: false, // صفحة المنتج الأب: اختيار أول متغيّر متوفّر تلقائياً عند الفتح
  quickAutoSelectVariant: false, // نفسه في نافذة الإضافة السريعة (إعداد مستقل)
  showRelated: true,          // شريط «قد يعجبك أيضاً» في صفحة المنتج
  showCartRecos: true,        // شريط «أضِف إلى طلبك» في صفحة السلة
  relatedTitle: "",           // عنوان شريط المنتجات المرتبطة (عربي) — فارغ = «قد يعجبك أيضاً»
  relatedTitleEn: "",         // نفسه بالإنجليزية — فارغ = "You may also like"
  // ── بطاقة الإهداء: تصميم الكارد وحقوله (إعدادات «بطاقات إهداء») ──
  // الميزة مقفولة فعلياً براية كل منتج (giftCard) وهي مطفأة افتراضياً، فهذا
  // المفتاح مفتاح إطفاء عام لا مفتاح تشغيل: لا يظهر شيء حتى يفعّل التاجر منتجاً.
  giftCard: {
    enabled: true,          // إطفاء عام يخفي الخيار من كل المنتجات دفعة واحدة
    showTo: true,           // حقل «إلى»
    showFrom: true,         // حقل «من»
    msgMax: 192,            // حد أحرف الرسالة (السقف الصلب على السيرفر 192)
    bgColor: "#ffffff",     // خلفية الكارد
    textColor: "#111111",   // نص الكارد
    accentColor: "#e8e8e8", // الفواصل وإطار الكارد
    logoUrl: "",            // لوجو يظهر على البطاقة
    logoPos: "top",         // top | bottom | none
    logoSize: 56,           // ارتفاع اللوجو (px)
  },
  loaderBgColor: "#ffffff",   // شاشة التحميل: لون الخلفية
  loaderTextColor: "#607878", // شاشة التحميل: لون اسم المتجر
  loaderAnim: "erase",        // erase | write | none | logo (لوجو الهيدر + نقاط)
  loaderLogoSize: 72,         // حجم اللوجو في شاشة التحميل
  loaderDotsGap: 22,          // المسافة بين اللوجو ونقاط التحميل (يقبل السالب)
  headerBgColor: "#ffffff",
  headerTextColor: "#1a1a1a",
  headerBtnBg: "transparent",
  headerBtnColor: "#1a1a1a",
  footerBgColor: "#607878",
  footerTextColor: "#ffffff",
  footerCopyrightText: "",
  footerCopyrightTextEn: "",
  footerLogoUrl: "",      // لوجو التذييل (إنجليزي) — مستقل عن لوجو الهيدر
  footerLogoUrlAr: "",    // لوجو التذييل (عربي)
  footerLogoSize: 36,
  velorciBadgeColor: "#65D4D2",
  velorciBadgeTextColor: "#E8FFFE",
  paymentImages: [],
  footerPayStyle: "classic",
  footerSocialStyle: "classic",
  footerNavStyle: "classic",
  serviceBoxEnabled: true,
  serviceBoxIconColor: "",
  serviceBoxItems: [
    { iconType: "shield",   title: "كفالة سنة",       subtitle: "على جميع منتجاتنا",       titleEn: "1-Year Warranty",    subtitleEn: "On all our products" },
    { iconType: "truck",    title: "الشحن والتوصيل",  subtitle: "لجميع مناطق الكويت",       titleEn: "Shipping & Delivery", subtitleEn: "All areas in Kuwait" },
    { iconType: "payment",  title: "دفع آمن",          subtitle: "خيارات دفع آمنة ومريحة",  titleEn: "Secure Payment",      subtitleEn: "Safe & convenient options" },
    { iconType: "clock",    title: "دعم 24/7",         subtitle: "مساعدة غير محدودة",        titleEn: "24/7 Support",        subtitleEn: "Unlimited assistance" },
  ],
  heroTitle: "اكتشف أحدث تشكيلاتنا",
  heroTitleEn: "Discover Our Latest Collection",
  heroSubtitle: "جودة عالية وأسعار مناسبة",
  heroSubtitleEn: "High quality & great prices",
  heroButtonText: "تسوق الآن",
  heroButtonTextEn: "Shop Now",
  heroBgImage: "",
  heroBgImageAr: "",
  heroBgMobile: "",
  heroBgMobileAr: "",
  bannerHeight: 400,
  heroOverlayOpacity: 0.35,
  // بنر متعدّد الصور — لو فاضية يُبنى سلايد واحد من حقول heroBg* أعلاه (توافق خلفي)
  bannerSlides: [],
  bannerAutoPlay: true,
  bannerInterval: 5,          // ثواني بين السلايدات
  announcementBar: { enabled: false, texts: [""], color: "#4ecb8d", position: "top", height: 36, speed: 4 },
  storeEnabled: true,
  storeClosedMessage: "المتجر مغلق حالياً",
  // أوقات عمل المتجر (فتح/إغلاق + أول وآخر أوردر لكل يوم) — معطّلة افتراضياً.
  // لا نضع الافتراضيات هنا عمداً: الأداة src/utils/storeHours.js تملأها عبر
  // normalizeHours()، فلا يدخل منطق الأوقات في الباندل الرئيسي (main.js).
  // storeHours: { enabled:false, timezone, closedMode, days:{0..6}, … }
  // عملات العرض في المتجر — مغلقة افتراضياً (كل متجر قائم يبقى بعملته الأساسية
  // وحدها بلا أي تغيير). الشكل الكامل والحارس في src/utils/displayCurrency.js؛
  // لا نضع القوائم هنا كي لا يدخل منطقها في الباندل الرئيسي.
  displayCurrencies: { enabled: false, list: [], rates: {}, round: {}, note: true },
  deliveryGovernorates: [],
  deliveryAreas: [],
  minOrderAmount: 0,
  freeDeliveryThreshold: 0,
  coupons: [],
  reviewsEnabled: true,
  reviewsRequireApproval: false,
  customerAccountsEnabled: false,
  otpTemplate: "",
  otpTemplateLang: "en",
  estimatedDeliveryDays: "2-3",
  estimatedDeliveryDaysEn: "",
  paymentMethods: { cashOnDelivery: true, kNet: false, creditCard: false },
  whatsappNumber: "",
  instagramUrl: "",
  twitterUrl: "",
  workingHours: "السبت - الخميس: 9ص - 9م",
  // ── أدوات التسويق والتتبّع (Pixels / Analytics / Catalog feed) ──
  // المستخدم يحط الـ id لكل أداة من إعدادات المتجر ← تبويب «التسويق».
  // فيد الكتالوج RSS مُولّد تلقائياً من /api/catalog-feed (ما يحتاج id).
  marketing: {
    facebookPixelId: "",      // معرّف فيسبوك بكسل (Meta Pixel ID)
    facebookCapiToken: "",    // توكن Conversion API (Access Token) للأحداث من السيرفر
    googleAnalyticsId: "",    // معرّف Google Analytics 4 (G-XXXXXXXXXX)
    tiktokPixelId: "",        // معرّف تيكتوك بكسل (TikTok Pixel ID)
  },
  attrDisplayMode: "tags",
  productsGridMobile: 2,
  productsGridDesktop: 2,
  productsGridImageRatio: 110, // بوكس صورة المنتج بصفحة المنتجات: ارتفاع كنسبة من العرض (%) — 75 عرضي، 100 مربع، 130 طولي
  saleBadgeType: "sale",
  saleBadgeColor: "#ff4757",
  productSections: [],
  customSections: [],
  animatedCarousels: [],
  footerLinks: { home: true, products: true, cart: true, checkout: true, about: true, privacy: true, returns: true },
  footerVisibleOn: { home: true, products: true, product: true, cart: true, checkout: true, success: true, page: true },
  pages: [
    { id: "about",   title: "من نحن",           titleEn: "About Us",       slug: "about",   content: "", contentEn: "", enabled: true },
    { id: "privacy", title: "سياسة الخصوصية",   titleEn: "Privacy Policy", slug: "privacy", content: "", contentEn: "", enabled: true },
    { id: "returns", title: "سياسة الاسترجاع",  titleEn: "Return Policy",  slug: "returns", content: "", contentEn: "", enabled: true },
  ],
  popup: {
    enabled: false,
    bgColor: "#ffffff",
    overlayColor: "#000000",
    overlayOpacity: 0.5,
    dismissOnOverlayClick: true,
    title: "",
    titleColor: "#1a2a2a",
    titleSize: 20,
    bodyText: "",
    bodyColor: "#555555",
    bodySize: 14,
    imageUrl: "",
    buttonEnabled: false,
    buttonText: "تسوق الآن",
    buttonColor: "#607878",
    buttonTextColor: "#ffffff",
    buttonSize: 13,
    buttonLink: "",
    copyEnabled: false,
    copyCode: "",
    copyButtonText: "نسخ الكود",
    copyButtonColor: "#4ecb8d",
    copyButtonTextColor: "#ffffff",
    copyButtonSize: 13,
    showOnce: true,
    delaySeconds: 0,
  },
};

export const DEFAULT_INVOICE_SETTINGS = {
  companyName: "Bekvam",
  storeName: "bekvam",
  companyRegistration: "",
  shippingMethod: "التوصيل",
  footerText: "",
  logoUrl: "",
  logoSize: 48,
  showCompanyName: true,
  showBarcode: true,
  showProductImages: true,
  showCustomerEmail: true,
  showDeliveryAddress: true,
  showProductDiscount: true,
  showDeliveryFee: true,
  showCoupon: true,
  showPaymentMethod: true,
  showReferenceNum: true,
  showOrderDate: true,
  showDueDate: true,
  showStoreName: true,
  showPaymentStatus: true,
  showShippingMethod: true,
  showInvoiceDeliveryDate: true,
  invoiceDeliveryDays: 0,

  // ── نوع الفاتورة ───────────────────────────────────────────────────────────
  // "standard" = الفاتورة الحالية (الافتراضي — لا يتغيّر شيء لأي شركة قائمة).
  // "receipt"  = الفاتورة المصغّرة (ريسيت طابعة حرارية) بعرض 80mm أو 58mm.
  invoiceTemplate: "standard",
  receiptWidth: 80,
  // أقسام الريسيت — كلها قابلة للفتح/الإغلاق من إعدادات الفاتورة.
  rcpShowLogo: true,          // اللوجو + اسم المطعم
  rcpShowStoreName: false,    // اسم الفرع/المخزن تحت الاسم
  rcpShowCompanyReg: false,   // رقم السجل التجاري
  rcpShowOrderDate: true,     // التاريخ/الوقت وموعد التوصيل
  rcpShowPaymentStatus: true, // حالة الدفع (كاش/مدفوعة)
  rcpShowCustomer: true,      // اسم العميل والهاتف
  rcpShowAddress: true,       // عنوان التوصيل
  rcpShowItemNotes: true,     // إضافات/ملاحظات كل صنف
  rcpShowPaymentMethod: true, // طريقة الدفع
  rcpShowBarcode: true,       // باركود رقم الطلب
  rcpShowFooter: true,        // سطر الشكر بالأسفل
  rcpFooterText: "",          // نصّه (فارغ = «شكراً لزيارتكم 🙏»)
};

export const DEFAULT_CARD_SETTINGS = {
  // الكارد الخارجي — BAND 1
  ext_deliveryDate:  true,
  ext_driverFee:     true,
  ext_invoiceNum:    true,
  // الكارد الخارجي — BAND 2
  ext_coupon:        true,
  ext_paymentMethod: true,
  // الكارد الخارجي — BAND 3
  ext_phone:         true,
  ext_repeatBadge:   true,
  ext_companyNote:   true,
  ext_urgentFlag:    true,
  ext_area:          true,
  // الكارد الخارجي — BAND 4
  ext_productImages: true,
  ext_timeEstimate:  true,
  ext_assignment:    true,
  ext_assign_tailor:  true,
  ext_assign_packing: true,
  ext_assign_driver:  true,
  // البطاقة الداخلية — السمري
  int_card_phone:        true,
  int_card_email:        true,
  int_card_area:         true,
  int_card_receivedAt:   true,
  int_card_deliveryChip: true,
  int_card_driverFee:    true,
  int_card_statusBadges: true,
  int_card_companyNote:  true,
  // البطاقة الداخلية — تاب الفاتورة
  int_inv_itemsSubtotal: true,
  int_inv_itemsDiscount: true,
  int_inv_coupon:        true,
  int_inv_deliveryFee:   true,
  int_inv_cashStatus:    true,
  // البطاقة الداخلية — تاب المنتجات
  int_prod_image:        true,
  int_prod_tailorStatus: true,
  int_prod_tailorReport: true,
};

export const DEFAULT_STAGES_CONFIG = [
  {id:"open",      label:"مفتوح",        labelEn:"Open",        color:"#f87171", icon:"📋"},
  {id:"progress",  label:"قيد التنفيذ",  labelEn:"In progress", color:"#f5a623", icon:"⚙️"},
  {id:"delivered", label:"تم التوصيل",   labelEn:"Delivered",   color:"#4ecb8d", icon:"🚚"},
  {id:"done",      label:"مكتمل",        labelEn:"Completed",   color:"#60a5fa", icon:"✅"},
];

export const STAGE_COLORS = ["#f87171","#f5a623","#60a5fa","#a78bfa","#4ecb8d","#607878","#f59e0b","#34d399","#fb7185","#818cf8"];

export const DEFAULT_REPORT_SETTINGS = {
  scheduledEnabled: false,
  scheduledTime: "23:00",
  scheduledDays: [0,1,2,3,4,5,6],
  waNumber: "",
};

export const WEEK_DAYS_AR = ["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"];

export const ARCHIVE_COL = "archive";
export const CHUNK_SIZE  = 200;
